// extracted by mini-css-extract-plugin
export var about = "about-large-module--about--7af5a";
export var btn = "about-large-module--btn--5c5b7";
export var btnBreak = "about-large-module--btnBreak--7a7e1";
export var container = "about-large-module--container--96359";
export var description = "about-large-module--description--9a22b";
export var heading = "about-large-module--heading--9647f";
export var mobileViewBtn = "about-large-module--mobileViewBtn--77084";
export var teamGrid = "about-large-module--teamGrid--aaf69";
export var teamSection = "about-large-module--teamSection--90b85";
export var textBox = "about-large-module--textBox--d2812";